import { makeCall, Methods } from "../../utils/makeCall";
import {
  ApiAdRecord,
  ApiCampaignData,
  CampaignState,
} from "../orderAd/orderAd.entity";
import {
  GetAdReportErrors,
  GetCampaignAdsErrors,
  GetPanelAdsErrors,
} from "./ordersList.error";
import { Pagination } from "../../utils/pagination";
import { CampaignErrors } from "../orderAd/orderAd.error";

export type GetPanelAdsRequest = Pagination;
export type GetPanelAdsResponse = ApiAdRecord[];

export const getPanelAds = makeCall<
  GetPanelAdsRequest,
  GetPanelAdsResponse,
  GetPanelAdsErrors
>(Methods.GetPanelAds);

export type GetAdReportRequest = { ad_id: string };
export type GetAdReportResponse = {
  ad_id: string;
  view_count: number;
  click_count: number;
  view_segments: number[];
  click_segments: number[];
  start_time: string;
};

export const getAdReport = makeCall<
  GetAdReportRequest,
  GetAdReportResponse,
  GetAdReportErrors
>(Methods.GetAdReport);

export type GetCampaignAdsRequest = Pagination;
export type GetCampaignAdsResponse = ApiCampaignData[];

export const getCampaignAds = makeCall<
  GetCampaignAdsRequest,
  GetCampaignAdsResponse,
  GetCampaignAdsErrors
>(Methods.GetCampaignAds);

export type ChangeCampaignStateRequest = {
  campaign_id: string;
  state: CampaignState.Active | CampaignState.Paused;
};

export type ChangeCampaignStopValueRequest = {
  ad_id: string;
  stop_value: number
};

export type ChangeCampaignStateResponse = undefined;
export type ChangeCampaignStopValueResponse = undefined;


export const changeCampaignStopValue = makeCall<
  ChangeCampaignStopValueRequest,
  ChangeCampaignStopValueResponse,
  CampaignErrors
>(Methods.ChangeCampaignStopValue);

export const changeCampaignState = makeCall<
  ChangeCampaignStateRequest,
  ChangeCampaignStateResponse,
  CampaignErrors
>(Methods.ChangeCampaignState);
